import {CompetitorCount} from "./competitor-count";
import {Organiser} from "./organizer";
import {RacePaymentInfo} from "./race-payment-info";
import {ApplicationFormSettings} from "./race-registration-form-settings";
import {RaceScoring} from "./race-scoring";
import {RaceSettings} from "./race-settings";

export class Race {
  id?: number;
  organiserId?: number;
  organiser?: Organiser;
  name?: string;
  nameEng?: string;
  nameIta?: string;
  nameSlo?: string;
  leagueName?: string;
  leagueNameEn?: string;
  leagueNameIt?: string;
  leagueNameSl?: string;
  status?: number;
  registrationStart?: Date;
  registrationEnd?: Date;
  raceStart?: Date;
  raceEnd?: Date;
  maxParticipants?: number;
  startEvery?: number;
  length?: number;
  ascent?: number;
  descent?: number;
  image?: number;
  imageIcon?: string;
  imageMini?: string;
  imageSmall?: string;
  imageMedium?: string;
  eventId?: number;
  ageGroupId?: number;
  config?: string;
  created?: Date;
  modified?: Date;
  competitorCount?: CompetitorCount;
  open?: boolean;
  competitorId?: number;
  paymentInfo?: RacePaymentInfo;
  favorite?: boolean;
  round?: number;
  registrationType?: number;
  sport?: number;
  virtualRace?: boolean;
  maxAltitude?: number;
  minAltitude?: number;
  shortDescription?: string;
  shortDescriptionEng?: string;
  shortDescriptionIta?: string;
  shortDescriptionSlo?: string;
  registrationMessage?: string;
  registrationMessageEng?: string;
  registrationMessageIta?: string;
  registrationMessageSlo?: string;
  checkpointAmount?: number;
  refreshmentCheckpointAmount?: number;
  raceScoring?: RaceScoring;
  raceSettings?: RaceSettings;
  applicationFormSettings?: ApplicationFormSettings;
  discountApplied?: boolean;
  raceRegistrationEnabled?: boolean;
  startCountry?: number;
  startCity?: string;
}
